import { Alert } from '@mui/material';
import { translateKey } from 'src/locales/translate';

interface UnconfirmedSaveBannerProps {
  /** `useOperationKey().pending`: the last attempt ended ambiguously (R3-4). */
  pending: boolean;
  /**
   * FW-2/13: a caller with its own wording, e.g. the document page, which
   * would otherwise show the same testid as a modal open on top of it
   * (two elements, one data-testid).
   */
  message?: string;
  testId?: string;
}

/**
 * R3-4: the previous save may have committed without an answer. The next
 * submit resends the same payload with the same key, so the form keeps its
 * fields locked and asks the user to save again.
 */
export default function UnconfirmedSaveBanner({
  pending,
  message,
  testId = 'warehouse-unconfirmed-save',
}: UnconfirmedSaveBannerProps): JSX.Element | null {
  if (!pending) {
    return null;
  }
  return (
    <Alert severity="warning" data-testid={testId} sx={{ mb: 2 }}>
      {message ?? translateKey('warehouse.common.unconfirmedSave')}
    </Alert>
  );
}
